export const doctorTrainingDashboardSorts = [
  {
    title: "Najwyższe oceny",
    sort: "rating",
    sortOrder: "desc",
  },
  {
    title: "Najniższe oceny",
    sort: "rating",
    sortOrder: "asc",
  },
  {
    title: "Wolne miejsca rosnąco",
    sort: "free_seats",
    sortOrder: "asc",
  },
  {
    title: "Wolne miejsca malejąco",
    sort: "free_seats",
    sortOrder: "desc",
  },
] as SortOption[];
